import { LocaleItemProps } from "apis";
import { lazy } from "react";

export const PageAdminLocale = lazy(() => import("./List"));
export const PageAdminLocaleCreate = lazy(() => import("./Add"));
export const PageAdminLocaleUpdate = lazy(() => import("./Edit"));

export interface FormLocaleValuesProps extends LocaleItemProps { }